import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { RoundedButton, RoundedButtonProps } from "../RoundedButton";
import { ReactComponent as AddIcon } from "./assets/add.svg";

export const AddTimeLogButton: FC<Partial<RoundedButtonProps>> = ({
  size = "md",
  ...props
}) => {
  const { t } = useTranslations();

  return (
    <RoundedButton
      size={size}
      color="#2196F3"
      icon={<AddIcon />}
      hint={t({
        id: "tasks-page.add-time-log",
        defaultMessage: "Add time log",
      })}
      {...props}
    />
  );
};
